import { defineStore } from 'pinia'
import api from '@/api/axios'
import { createProvidersImportFormData } from '@/utils/providerImport.mjs'

const getProviderId = (provider) => provider?.id || provider?._id?.$oid || provider?._id || null

export const useProvidersStore = defineStore('providers', {
    state: () => ({
        providers: {
            items: [],
            count: 0
        },
        currentProvider: null,
        pageSize: 20,
    }),
    getters: {
        allProviders: (state) =>
            state.providers.items.map((provider) => ({
                ...provider,
                id: getProviderId(provider),
            })),
        countPages: (state) => Math.ceil(state.providers.count / state.pageSize) || 1,
    },

    actions: {
        async getProviders(page = 1, filter = {}, limit = null) {
            try {
                const query = {
                    ...filter,
                    limit: limit === null ? this.pageSize : limit,
                    page,
                };
                const urlFilter = new URLSearchParams(query).toString();
                const response = await api.get('/providers?' + urlFilter);
                this.providers = response.data;
            } catch (error) {
                console.error('Failed to fetch providers:', error);
                throw error;
            }
        },

        async getProvider(id) {
            try {
                const response = await api.get(`/providers/${id}`);
                this.currentProvider = response.data;
            } catch (error) {
                console.error('Failed to fetch provider:', error);
                throw error;
            }
        },

        async addProvider(providerData) {
            try {
                const response = await api.post('/providers', providerData);
                if (!Array.isArray(this.providers.items)) {
                    this.providers.items = [];
                }
                this.providers.items.push(response.data);
                this.providers.count += 1;
                this.currentProvider = response.data;
                return response.data;
            } catch (error) {
                console.error('Failed to add provider:', error);
                throw error;
            }
        },

        async updateProvider(id, providerData) {
            try {
                const response = await api.put(`/providers/${id}`, providerData);
                const index = this.providers.items.findIndex((provider) => String(getProviderId(provider)) === String(id));
                if (index !== -1) {
                    this.providers.items[index] = response.data;
                }
                this.currentProvider = response.data;
                return response.data;
            } catch (error) {
                console.error('Failed to update provider:', error);
                throw error;
            }
        },

        async previewProvidersImport(file, mapping) {
            try {
                const response = await api.post(
                    '/import/providers/preview',
                    createProvidersImportFormData(file, mapping)
                );
                return response.data;
            } catch (error) {
                console.error('Failed to preview providers import:', error);
                throw error;
            }
        },

        async confirmProvidersImport(sessionId) {
            try {
                const response = await api.post(`/import/providers/${encodeURIComponent(sessionId)}/confirm`);
                return response.data;
            } catch (error) {
                console.error('Failed to confirm providers import:', error);
                throw error;
            }
        },
        //
        // async deleteProvider(id) {
        //     try {
        //         await api.delete(`/providers/${id}`);
        //         this.providers = this.providers.filter((p) => p.id !== id);
        //     } catch (error) {
        //         console.error('Failed to delete provider:', error);
        //         throw error;
        //     }
        // },
    },
});
